import SpinPremiaForm from './SpinPremiaForm';
export default SpinPremiaForm;
export * from './SpinPremiaForm';
